export function suggestPrice(sales: number[]) {
  if (!sales.length) return { floor: null, median: null, suggested: null };
  
  const s = [...sales].sort((a, b) => a - b);
  
  const q = (p: number) => {
    const i = (s.length - 1) * p;
    const lo = Math.floor(i);
    const hi = Math.ceil(i);
    return lo === hi ? s[lo] : s[lo] + (s[hi] - s[lo]) * (i - lo);
  };
  
  const median = q(0.5);
  const q1 = q(0.25);
  const q3 = q(0.75);
  const iqr = q3 - q1 || median * 0.15;
  
  return {
    floor: +Math.max(0, median - 0.5 * iqr).toFixed(2),
    median: +median.toFixed(2),
    suggested: +(median + 0.3 * iqr).toFixed(2),
  };
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
}

export function calculateMargin(buyPrice: number, sellPrice: number): number {
  return sellPrice - buyPrice;
}

export function calculateMarginPercent(buyPrice: number, sellPrice: number): number {
  if (buyPrice === 0) return 0;
  return ((sellPrice - buyPrice) / buyPrice) * 100;
}
